import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, HostBinding, NgModule, inject, Optional, ChangeDetectorRef, ViewChild } from '@angular/core';
import * as i2 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@spartacus/core';
import { GlobalMessageType, useFeatureStyles, UrlModule, I18nModule, FeaturesConfigModule, provideDefaultConfig, NotAuthGuard, AuthService, GlobalMessageService, WindowRef, RoutingService, AuthGuard } from '@spartacus/core';
import * as i4 from '@spartacus/storefront';
import { CustomFormValidators, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, PageSlotModule, BtnLikeLinkModule, DomChangeModule, DIALOG_TYPE, LaunchDialogService, KeyboardFocusModule, IconModule } from '@spartacus/storefront';
import { BehaviorSubject, from, of, tap as tap$1 } from 'rxjs';
import { tap, withLatestFrom, switchMap } from 'rxjs/operators';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2$1 from '@spartacus/user/account/root';
import { VerificationTokenFacade, VERIFICATION_TOKEN_DIALOG_ACTION } from '@spartacus/user/account/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = () => ({
  cxRoute: "forgotPassword"
});
const _c1 = a0 => ({
  label: a0
});
function LoginFormComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 13);
  }
}
function LoginFormComponent_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), " ");
  }
}
function LoginFormComponent_ng_template_8_Template(rf, ctx) {}
function LoginFormComponent_cx_form_errors_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 15);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c1, i0.ɵɵpipeBind1(1, 2, "loginForm.emailAddress.label")))("control", ctx_r1.form.get("userId"));
  }
}
function LoginFormComponent_cx_form_errors_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 16);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("userId"));
  }
}
function LoginFormComponent_ng_template_17_Template(rf, ctx) {}
function LoginFormComponent_cx_form_errors_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 17);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c1, i0.ɵɵpipeBind1(1, 2, "loginForm.password.label")))("control", ctx_r1.form.get("password"));
  }
}
function LoginFormComponent_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 16);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("password"));
  }
}
function LoginFormComponent_ng_template_30_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 19);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function LoginFormComponent_ng_template_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LoginFormComponent_ng_template_30_abbr_0_Template, 3, 3, "abbr", 18);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
const _c2 = () => ({
  cxRoute: "register"
});
const _c3 = () => ({
  cxRoute: "checkoutLogin"
});
function LoginRegisterComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 3);
    i0.ɵɵlistener("click", function LoginRegisterComponent_ng_container_4_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateTo(ctx_r1.loginAsGuest ? "checkoutLogin" : "register"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.loginAsGuest ? "btn-guest" : "btn-register");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx_r1.loginAsGuest ? "loginForm.guestCheckout" : "loginForm.register"), " ");
  }
}
function LoginRegisterComponent_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 5);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c2)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "loginForm.register"));
  }
}
function LoginRegisterComponent_ng_container_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 6);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "loginForm.guestCheckout"));
  }
}
function LoginRegisterComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoginRegisterComponent_ng_container_5_ng_container_1_Template, 5, 7, "ng-container", 4)(2, LoginRegisterComponent_ng_container_5_ng_container_2_Template, 5, 7, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.loginAsGuest);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loginAsGuest);
  }
}
const _c4 = () => ({
  cxRoute: "login"
});
function LoginComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "cx-page-slot", 4);
    i0.ɵɵlistener("cxDomChange", function LoginComponent_ng_container_0_ng_container_1_Template_cx_page_slot_cxDomChange_4_listener($event) {
      const greeting_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onRootNavBtnAdded($event, greeting_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ctx_r2.greeting$), " ");
  }
}
function LoginComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoginComponent_ng_container_0_ng_container_1_Template, 5, 3, "ng-container", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.greeting$));
  }
}
function LoginComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpureFunction0(6, _c4)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "miniLogin.signInRegister"));
  }
}
const _c5 = () => ({
  cxRoute: "logout"
});
function MyAccountV2UserComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 3);
    i0.ɵɵpipe(4, "cxUrl");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const user_r1 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", user_r1.title, "", user_r1.name, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(4, 4, i0.ɵɵpureFunction0(8, _c5)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 6, "myAccountV2User.signOut"), " ");
  }
}
function OneTimePasswordLoginFormComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 12);
  }
}
function OneTimePasswordLoginFormComponent_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), " ");
  }
}
function OneTimePasswordLoginFormComponent_ng_template_8_Template(rf, ctx) {}
function OneTimePasswordLoginFormComponent_ng_template_16_Template(rf, ctx) {}
function OneTimePasswordLoginFormComponent_ng_template_28_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 15);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function OneTimePasswordLoginFormComponent_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OneTimePasswordLoginFormComponent_ng_template_28_abbr_0_Template, 3, 3, "abbr", 14);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function VerificationTokenDialogComponent_h3_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "verificationTokenDialog.title"), " ");
  }
}
function VerificationTokenDialogComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "verificationTokenDialog.title"), " ");
  }
}
const _c6 = ["noReceiveCodeLink"];
const _c7 = ["resendLink"];
const _c8 = a0 => ({
  seconds: a0
});
const _c9 = a0 => ({
  "disabled-link": a0
});
const _c10 = a0 => ({
  waitTime: a0
});
function VerificationTokenFormComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 17);
  }
}
function VerificationTokenFormComponent_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), " ");
  }
}
function VerificationTokenFormComponent_ng_template_8_Template(rf, ctx) {}
function VerificationTokenFormComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "register.rateLimitForRegistrationMessage", i0.ɵɵpureFunction1(4, _c8, ctx_r1.waitTimeForRateLimit)), " ");
  }
}
function VerificationTokenFormComponent_div_17_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "verificationTokenForm.sendRateLime", i0.ɵɵpureFunction1(4, _c10, ctx_r1.waitTime)), " ");
  }
}
function VerificationTokenFormComponent_div_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21)(2, "span", 22)(3, "a", 23, 1);
    i0.ɵɵlistener("keydown.enter", function VerificationTokenFormComponent_div_17_Template_a_keydown_enter_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    })("keydown.space", function VerificationTokenFormComponent_div_17_Template_a_keydown_space_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    })("click", function VerificationTokenFormComponent_div_17_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, VerificationTokenFormComponent_div_17_ng_container_7_Template, 3, 6, "ng-container", 24);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 25)(9, "a", 26, 2);
    i0.ɵɵlistener("keydown", function VerificationTokenFormComponent_div_17_Template_a_keydown_9_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOpenInfoDailogKeyDown($event));
    })("click", function VerificationTokenFormComponent_div_17_Template_a_click_9_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openInfoDailog());
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c9, ctx_r1.isResendDisabled));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "verificationTokenForm.resend"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isResendDisabled);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 6, "verificationTokenForm.noReceiveCode"), " ");
  }
}
function VerificationTokenFormComponent_ng_template_26_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 28);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function VerificationTokenFormComponent_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VerificationTokenFormComponent_ng_template_26_abbr_0_Template, 3, 3, "abbr", 27);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
let LoginFormComponentService = /*#__PURE__*/(() => {
  class LoginFormComponentService {
    constructor(auth, globalMessage, winRef) {
      this.auth = auth;
      this.globalMessage = globalMessage;
      this.winRef = winRef;
      this.busy$ = new BehaviorSubject(false);
      this.isUpdating$ = this.busy$.pipe(tap(state => {
        const userId = this.winRef.nativeWindow?.history?.state?.['newUid'];
        if (userId) {
          this.form.patchValue({
            userId
          });
        }
        state === true ? this.form.disable() : this.form.enable();
      }));
      this.form = new UntypedFormGroup({
        userId: new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator]),
        password: new UntypedFormControl('', Validators.required)
      });
    }
    login() {
      if (!this.form.valid) {
        this.form.markAllAsTouched();
        return;
      }
      this.busy$.next(true);
      from(this.auth.loginWithCredentials(
      // TODO: consider dropping toLowerCase as this should not be part of the UI,
      // as it's too opinionated and doesn't work with other AUTH services
      this.form.value.userId.toLowerCase(), this.form.value.password)).pipe(withLatestFrom(this.auth.isUserLoggedIn()), tap(([_, isLoggedIn]) => this.onSuccess(isLoggedIn))).subscribe();
    }
    onSuccess(isLoggedIn) {
      if (isLoggedIn) {
        // We want to remove error messages on successful login (primary the bad
        // username/password combination)
        this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
        this.form.reset();
      }
      this.busy$.next(false);
    }
    static {
      this.ɵfac = function LoginFormComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginFormComponentService)(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i1.GlobalMessageService), i0.ɵɵinject(i1.WindowRef));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LoginFormComponentService,
        factory: LoginFormComponentService.ɵfac
      });
    }
  }
  return LoginFormComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let LoginFormComponent = /*#__PURE__*/(() => {
  class LoginFormComponent {
    constructor(service) {
      this.service = service;
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
      this.style = true;
      useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    }
    onSubmit() {
      this.service.login();
    }
    static {
      this.ɵfac = function LoginFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginFormComponent)(i0.ɵɵdirectiveInject(LoginFormComponentService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginFormComponent,
        selectors: [["cx-login-form"]],
        hostVars: 2,
        hostBindings: function LoginFormComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("user-form", ctx.style);
          }
        },
        standalone: false,
        decls: 32,
        vars: 39,
        consts: [["requiredAsterisk", ""], ["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], ["class", "form-legend", 4, "cxFeature"], [1, "label-content"], [3, "ngTemplateOutlet"], ["required", "true", "type", "email", "formControlName", "userId", 1, "form-control", 3, "placeholder"], ["id", "userIdError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "formControlName", "password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", "aria-live", "off", 3, "translationParams", "control", 4, "cxFeature"], [1, "btn-link", 3, "routerLink"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], [1, "form-legend"], ["id", "userIdError", "aria-live", "off", 3, "translationParams", "control"], [3, "control"], ["id", "passwordError", "aria-live", "off", 3, "translationParams", "control"], ["class", "text-decoration-none required-asterisk", "aria-hidden", "true", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
        template: function LoginFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, LoginFormComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelementStart(2, "form", 2);
            i0.ɵɵlistener("ngSubmit", function LoginFormComponent_Template_form_ngSubmit_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSubmit());
            });
            i0.ɵɵtemplate(3, LoginFormComponent_p_3_Template, 3, 3, "p", 3);
            i0.ɵɵelementStart(4, "label")(5, "span", 4);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵtemplate(8, LoginFormComponent_ng_template_8_Template, 0, 0, "ng-template", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input", 6);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵtemplate(11, LoginFormComponent_cx_form_errors_11_Template, 2, 6, "cx-form-errors", 7)(12, LoginFormComponent_cx_form_errors_12_Template, 1, 1, "cx-form-errors", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "label")(14, "span", 4);
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "cxTranslate");
            i0.ɵɵtemplate(17, LoginFormComponent_ng_template_17_Template, 0, 0, "ng-template", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(18, "input", 9);
            i0.ɵɵpipe(19, "cxTranslate");
            i0.ɵɵpipe(20, "cxTranslate");
            i0.ɵɵtemplate(21, LoginFormComponent_cx_form_errors_21_Template, 2, 6, "cx-form-errors", 10)(22, LoginFormComponent_cx_form_errors_22_Template, 1, 1, "cx-form-errors", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "a", 11);
            i0.ɵɵpipe(24, "cxUrl");
            i0.ɵɵtext(25);
            i0.ɵɵpipe(26, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "button", 12);
            i0.ɵɵtext(28);
            i0.ɵɵpipe(29, "cxTranslate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(30, LoginFormComponent_ng_template_30_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const requiredAsterisk_r3 = i0.ɵɵreference(31);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 20, ctx.isUpdating$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 22, "loginForm.emailAddress.label"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 24, "loginForm.emailAddress.placeholder"));
            i0.ɵɵattribute("aria-describedby", "userIdError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 26, "loginForm.password.label"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 28, "loginForm.password.placeholder"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(20, 30, "loginForm.password.placeholder"))("aria-describedby", "passwordError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(24, 32, i0.ɵɵpureFunction0(38, _c0)));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 34, "loginForm.forgotPassword"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.form.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(29, 36, "loginForm.signIn"), " ");
          }
        },
        dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.FormGroupDirective, i2.FormControlName, i1$2.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i4.PasswordVisibilityToggleDirective, i1.FeatureDirective, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return LoginFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let LoginFormModule = /*#__PURE__*/(() => {
  class LoginFormModule {
    static {
      this.ɵfac = function LoginFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LoginFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            ReturningCustomerLoginComponent: {
              component: LoginFormComponent,
              guards: [NotAuthGuard],
              providers: [{
                provide: LoginFormComponentService,
                useClass: LoginFormComponentService,
                deps: [AuthService, GlobalMessageService, WindowRef]
              }]
            }
          }
        })],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule]
      });
    }
  }
  return LoginFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let LoginRegisterComponent = /*#__PURE__*/(() => {
  class LoginRegisterComponent {
    constructor(activatedRoute) {
      this.activatedRoute = activatedRoute;
      this.loginAsGuest = false;
      this.routingService = inject(RoutingService, {
        optional: true
      });
    }
    ngOnInit() {
      this.loginAsGuest = this.activatedRoute.snapshot.queryParams['forced'];
    }
    navigateTo(cxRoute) {
      this.routingService?.go({
        cxRoute
      });
    }
    static {
      this.ɵfac = function LoginRegisterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginRegisterComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginRegisterComponent,
        selectors: [["cx-login-register"]],
        standalone: false,
        decls: 6,
        vars: 5,
        consts: [[1, "register"], [1, "cx-section-title"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-secondary", 3, "click", "ngClass"], [4, "ngIf"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", "btn-register", 3, "routerLink"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", "btn-guest", 3, "routerLink"]],
        template: function LoginRegisterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "p", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, LoginRegisterComponent_ng_container_4_Template, 4, 4, "ng-container", 2)(5, LoginRegisterComponent_ng_container_5_Template, 3, 2, "ng-container", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "loginForm.dontHaveAccount"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf, i1$2.RouterLink, i1.FeatureDirective, i4.BtnLikeLinkDirective, i1.UrlPipe, i1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return LoginRegisterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let LoginRegisterModule = /*#__PURE__*/(() => {
  class LoginRegisterModule {
    static {
      this.ɵfac = function LoginRegisterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginRegisterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LoginRegisterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            ReturningCustomerRegisterComponent: {
              component: LoginRegisterComponent,
              guards: [NotAuthGuard]
            }
          }
        })],
        imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, FeaturesConfigModule, BtnLikeLinkModule]
      });
    }
  }
  return LoginRegisterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let LoginComponent = /*#__PURE__*/(() => {
  class LoginComponent {
    constructor(auth, userAccount, translation) {
      this.auth = auth;
      this.userAccount = userAccount;
      this.translation = translation;
      useFeatureStyles('a11yMyAccountLinkOutline');
    }
    ngOnInit() {
      this.user$ = this.auth.isUserLoggedIn().pipe(switchMap(isUserLoggedIn => {
        if (isUserLoggedIn) {
          return this.userAccount.get();
        } else {
          return of(undefined);
        }
      }));
      this.greeting$ = this.user$.pipe(switchMap(user => this.translation.translate(`miniLogin.userGreeting`, {
        name: user?.name
      })));
    }
    onRootNavBtnAdded($event, greeting) {
      $event.target.setAttribute('aria-label', greeting);
    }
    static {
      this.ɵfac = function LoginComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginComponent)(i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(i2$1.UserAccountFacade), i0.ɵɵdirectiveInject(i1.TranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginComponent,
        selectors: [["cx-login"]],
        standalone: false,
        decls: 4,
        vars: 4,
        consts: [["login", ""], [4, "ngIf", "ngIfElse"], [4, "ngIf"], [1, "cx-login-greet"], ["cxDomChangeTargetSelector", "nav ul li:first-child button", "id", "account-nav", "position", "HeaderLinks", 3, "cxDomChange"], ["role", "link", 3, "routerLink"]],
        template: function LoginComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, LoginComponent_ng_container_0_Template, 3, 3, "ng-container", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, LoginComponent_ng_template_2_Template, 4, 7, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const login_r4 = i0.ɵɵreference(3);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.user$))("ngIfElse", login_r4);
          }
        },
        dependencies: [i1$1.NgIf, i1$2.RouterLink, i4.PageSlotComponent, i4.DomChangeDirective, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return LoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let LoginModule = /*#__PURE__*/(() => {
  class LoginModule {
    static {
      this.ɵfac = function LoginModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LoginModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            LoginComponent: {
              component: LoginComponent
            }
          }
        })],
        imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, DomChangeModule]
      });
    }
  }
  return LoginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MyAccountV2UserComponent = /*#__PURE__*/(() => {
  class MyAccountV2UserComponent extends LoginComponent {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵMyAccountV2UserComponent_BaseFactory;
        return function MyAccountV2UserComponent_Factory(__ngFactoryType__) {
          return (ɵMyAccountV2UserComponent_BaseFactory || (ɵMyAccountV2UserComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2UserComponent)))(__ngFactoryType__ || MyAccountV2UserComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MyAccountV2UserComponent,
        selectors: [["cx-my-account-v2-user"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 3,
        consts: [[1, "cx-my-account-v2-user"], [4, "ngIf"], [1, "cx-name"], [1, "cx-sign-out", 3, "routerLink"]],
        template: function MyAccountV2UserComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, MyAccountV2UserComponent_ng_container_1_Template, 7, 9, "ng-container", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx.user$));
          }
        },
        dependencies: [i1$1.NgIf, i1$2.RouterLink, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return MyAccountV2UserComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MyAccountV2UserModule = /*#__PURE__*/(() => {
  class MyAccountV2UserModule {
    static {
      this.ɵfac = function MyAccountV2UserModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MyAccountV2UserModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MyAccountV2UserModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            MyAccountViewUserComponent: {
              component: MyAccountV2UserComponent,
              guards: [AuthGuard]
            }
          }
        })],
        imports: [CommonModule, RouterModule, UrlModule, I18nModule]
      });
    }
  }
  return MyAccountV2UserModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ONE_TIME_PASSWORD_LOGIN_PURPOSE = 'LOGIN';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OneTimePasswordLoginFormComponent = /*#__PURE__*/(() => {
  class OneTimePasswordLoginFormComponent {
    constructor() {
      this.routingService = inject(RoutingService);
      this.verificationTokenFacade = inject(VerificationTokenFacade);
      this.winRef = inject(WindowRef);
      this.busy$ = new BehaviorSubject(false);
      this.isUpdating$ = this.busy$.pipe(tap$1(state => {
        const userId = this.winRef.nativeWindow?.history?.state?.['newUid'];
        if (userId) {
          this.form.patchValue({
            userId
          });
        }
        state === true ? this.form.disable() : this.form.enable();
      }));
      this.form = new UntypedFormGroup({
        userId: new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator]),
        password: new UntypedFormControl('', Validators.required)
      });
      this.style = true;
      useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    }
    onSubmit() {
      if (!this.form.valid) {
        this.form.markAllAsTouched();
        return;
      }
      this.busy$.next(true);
      const verificationTokenCreation = this.collectDataFromLoginForm();
      this.verificationTokenFacade.createVerificationToken(verificationTokenCreation).subscribe({
        next: result => this.goToVerificationTokenForm(result, verificationTokenCreation),
        error: error => {
          this.routingService.go({
            cxRoute: 'verifyToken'
          }, {
            state: {
              loginId: verificationTokenCreation.loginId,
              password: verificationTokenCreation.password,
              errorStatus: error.status
            }
          });
          this.busy$.next(false);
        },
        complete: () => this.onCreateVerificationTokenComplete()
      });
    }
    goToVerificationTokenForm(verificationToken, verificationTokenCreation) {
      this.routingService.go({
        cxRoute: 'verifyToken'
      }, {
        state: {
          loginId: verificationTokenCreation.loginId,
          password: verificationTokenCreation.password,
          tokenId: verificationToken.tokenId,
          expiresIn: verificationToken.expiresIn
        }
      });
    }
    onCreateVerificationTokenComplete() {
      this.form.reset();
      this.busy$.next(false);
    }
    collectDataFromLoginForm() {
      return {
        // TODO: consider dropping toLowerCase as this should not be part of the UI,
        // as it's too opinionated and doesn't work with other AUTH services
        loginId: this.form.value.userId.toLowerCase(),
        password: this.form.value.password,
        purpose: ONE_TIME_PASSWORD_LOGIN_PURPOSE
      };
    }
    static {
      this.ɵfac = function OneTimePasswordLoginFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OneTimePasswordLoginFormComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OneTimePasswordLoginFormComponent,
        selectors: [["cx-otp-login-form"]],
        hostVars: 2,
        hostBindings: function OneTimePasswordLoginFormComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("user-form", ctx.style);
          }
        },
        standalone: false,
        decls: 30,
        vars: 37,
        consts: [["requiredAsterisk", ""], ["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], ["class", "form-legend", 4, "cxFeature"], [1, "label-content"], [3, "ngTemplateOutlet"], ["required", "true", "type", "email", "formControlName", "userId", 1, "form-control", 3, "placeholder"], ["id", "userIdError", "aria-live", "off", 3, "control"], ["required", "true", "type", "password", "formControlName", "password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", "aria-live", "off", 3, "control"], [1, "btn-link", 3, "routerLink"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], [1, "form-legend"], ["aria-hidden", "true", "class", "text-decoration-none required-asterisk", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
        template: function OneTimePasswordLoginFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, OneTimePasswordLoginFormComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelementStart(2, "form", 2);
            i0.ɵɵlistener("ngSubmit", function OneTimePasswordLoginFormComponent_Template_form_ngSubmit_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSubmit());
            });
            i0.ɵɵtemplate(3, OneTimePasswordLoginFormComponent_p_3_Template, 3, 3, "p", 3);
            i0.ɵɵelementStart(4, "label")(5, "span", 4);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵtemplate(8, OneTimePasswordLoginFormComponent_ng_template_8_Template, 0, 0, "ng-template", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input", 6);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵelement(11, "cx-form-errors", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "label")(13, "span", 4);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "cxTranslate");
            i0.ɵɵtemplate(16, OneTimePasswordLoginFormComponent_ng_template_16_Template, 0, 0, "ng-template", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(17, "input", 8);
            i0.ɵɵpipe(18, "cxTranslate");
            i0.ɵɵpipe(19, "cxTranslate");
            i0.ɵɵelement(20, "cx-form-errors", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "a", 10);
            i0.ɵɵpipe(22, "cxUrl");
            i0.ɵɵtext(23);
            i0.ɵɵpipe(24, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "button", 11);
            i0.ɵɵtext(26);
            i0.ɵɵpipe(27, "cxTranslate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(28, OneTimePasswordLoginFormComponent_ng_template_28_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const requiredAsterisk_r2 = i0.ɵɵreference(29);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 18, ctx.isUpdating$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 20, "loginForm.emailAddress.label"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r2);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 22, "loginForm.emailAddress.placeholder"));
            i0.ɵɵattribute("aria-describedby", "userIdError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("control", ctx.form.get("userId"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 24, "loginForm.password.label"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r2);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 26, "loginForm.password.placeholder"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(19, 28, "loginForm.password.placeholder"))("aria-describedby", "passwordError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("control", ctx.form.get("password"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(22, 30, i0.ɵɵpureFunction0(36, _c0)));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 32, "loginForm.forgotPassword"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.form.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 34, "loginForm.signIn"), " ");
          }
        },
        dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.FormGroupDirective, i2.FormControlName, i1$2.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i4.PasswordVisibilityToggleDirective, i1.FeatureDirective, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return OneTimePasswordLoginFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OneTimePasswordLoginFormModeule = /*#__PURE__*/(() => {
  class OneTimePasswordLoginFormModeule {
    static {
      this.ɵfac = function OneTimePasswordLoginFormModeule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OneTimePasswordLoginFormModeule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OneTimePasswordLoginFormModeule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            ReturningCustomerOTPLoginComponent: {
              component: OneTimePasswordLoginFormComponent,
              guards: [NotAuthGuard]
            }
          }
        })],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule]
      });
    }
  }
  return OneTimePasswordLoginFormModeule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let VerificationTokenDialogComponent = /*#__PURE__*/(() => {
  class VerificationTokenDialogComponent {
    constructor(launchDialogService) {
      this.launchDialogService = launchDialogService;
      this.VERIFICATION_TOKEN_DIALOG_ACTION = VERIFICATION_TOKEN_DIALOG_ACTION;
      this.focusConfig = {
        trap: true,
        block: true,
        autofocus: true,
        focusOnEscape: true
      };
    }
    closeModal(reason) {
      this.launchDialogService.closeDialog(reason);
    }
    static {
      this.ɵfac = function VerificationTokenDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VerificationTokenDialogComponent)(i0.ɵɵdirectiveInject(i4.LaunchDialogService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VerificationTokenDialogComponent,
        selectors: [["cx-verification-token-dialog"]],
        standalone: false,
        decls: 28,
        vars: 21,
        consts: [["role", "dialog", "aria-labelledby", "verification-token-dialog-title", 1, "cx-verification-token-dialog", "cx-modal-container", "cx-asm-dialog", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], [1, "info-icon"], ["type", "INFO"], ["id", "verification-token-dialog-title", "class", "title modal-title", 4, "cxFeature"], [1, "spliter"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row"], [1, "cx-dialog-item"], [1, "cx-dialog-footer", "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["id", "verification-token-dialog-title", 1, "title", "modal-title"]],
        template: function VerificationTokenDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("esc", function VerificationTokenDialogComponent_Template_div_esc_0_listener() {
              return ctx.closeModal(ctx.VERIFICATION_TOKEN_DIALOG_ACTION.OK);
            });
            i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div")(4, "span", 3);
            i0.ɵɵelement(5, "cx-icon", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, VerificationTokenDialogComponent_h3_6_Template, 3, 3, "h3", 5)(7, VerificationTokenDialogComponent_span_7_Template, 3, 3, "span", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "hr", 6);
            i0.ɵɵelementStart(9, "div", 7)(10, "div", 8)(11, "div", 9);
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 9);
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "div", 9);
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "div", 9);
            i0.ɵɵtext(21);
            i0.ɵɵpipe(22, "cxTranslate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(23, "div", 10)(24, "button", 11);
            i0.ɵɵpipe(25, "cxTranslate");
            i0.ɵɵlistener("click", function VerificationTokenDialogComponent_Template_button_click_24_listener() {
              return ctx.closeModal(ctx.VERIFICATION_TOKEN_DIALOG_ACTION.OK);
            });
            i0.ɵɵtext(26);
            i0.ɵɵpipe(27, "cxTranslate");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("cxFocus", ctx.focusConfig);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 9, "verificationTokenDialog.noReceiveCode"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 11, "verificationTokenDialog.contentLine1"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 13, "verificationTokenDialog.contentLine2"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 15, "verificationTokenDialog.contentLine3"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(25, 17, "verificationTokenDialog.ok"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 19, "verificationTokenDialog.close"), " ");
          }
        },
        dependencies: [i4.FocusDirective, i4.IconComponent, i1.FeatureDirective, i1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return VerificationTokenDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultVerificationTokenLayoutConfig = {
  launch: {
    ["ACCOUNT_VERIFICATION_TOKEN" /* LAUNCH_CALLER.ACCOUNT_VERIFICATION_TOKEN */]: {
      inlineRoot: true,
      component: VerificationTokenDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const globalMsgShowTime = 10000;
let VerificationTokenFormComponentService = /*#__PURE__*/(() => {
  class VerificationTokenFormComponentService {
    constructor() {
      this.globalMessage = inject(GlobalMessageService);
      this.verificationTokenFacade = inject(VerificationTokenFacade);
      this.auth = inject(AuthService);
      this.busy$ = new BehaviorSubject(false);
      this.isUpdating$ = this.busy$.pipe(tap(state => {
        state === true ? this.form.disable() : this.form.enable();
      }));
      this.form = new UntypedFormGroup({
        tokenId: new UntypedFormControl('', [Validators.required]),
        tokenCode: new UntypedFormControl('', [Validators.required])
      });
    }
    login() {
      if (!this.form.valid) {
        this.form.markAllAsTouched();
        return;
      }
      this.busy$.next(true);
      from(this.auth.otpLoginWithCredentials(this.form.value.tokenId, this.form.value.tokenCode)).pipe(withLatestFrom(this.auth.isUserLoggedIn()), tap(([_, isLoggedIn]) => this.onSuccess(isLoggedIn))).subscribe();
    }
    displayMessage(key, params) {
      this.globalMessage.add({
        key: key,
        params
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION, globalMsgShowTime);
    }
    createVerificationToken(loginId, password, purpose) {
      return this.verificationTokenFacade.createVerificationToken({
        loginId,
        password,
        purpose
      });
    }
    onSuccess(isLoggedIn) {
      if (isLoggedIn) {
        // We want to remove error messages on successful login (primary the bad
        // username/password combination)
        this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
        this.form.reset();
      }
      this.busy$.next(false);
    }
    static {
      this.ɵfac = function VerificationTokenFormComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VerificationTokenFormComponentService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VerificationTokenFormComponentService,
        factory: VerificationTokenFormComponentService.ɵfac
      });
    }
  }
  return VerificationTokenFormComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let VerificationTokenFormComponent = /*#__PURE__*/(() => {
  class VerificationTokenFormComponent {
    constructor() {
      this.service = inject(VerificationTokenFormComponentService);
      this.launchDialogService = inject(LaunchDialogService);
      this.cdr = inject(ChangeDetectorRef);
      this.routingService = inject(RoutingService);
      this.waitTime = 60;
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
      this.style = true;
      this.isResendDisabled = true;
      this.waitTimeForRateLimit = 300;
    }
    ngOnInit() {
      if (!!history.state) {
        this.tokenId = history.state['tokenId'];
        this.password = history.state['password'];
        this.target = history.state['loginId'];
        this.errorStatus = history.state['errorStatus'];
        history.pushState({
          tokenId: '',
          password: '',
          loginId: '',
          errorStatus: ''
        }, 'verifyToken');
        if (this.errorStatus === 400) {
          this.upToRateLimit = true;
          this.tokenId = 'invalidTokenId';
          this.startRateLimitWaitTimeInterval();
        } else if (!this.target || !this.password || !this.tokenId) {
          this.service.displayMessage('verificationTokenForm.needInputCredentials', {});
          this.routingService.go(['/login']);
        } else {
          this.startWaitTimeInterval();
          this.service.displayMessage('verificationTokenForm.createVerificationToken', {
            target: this.target
          });
        }
      }
    }
    onSubmit() {
      this.service.login();
    }
    resendOTP() {
      this.isResendDisabled = true;
      this.resendLink.nativeElement.tabIndex = -1;
      this.resendLink.nativeElement.blur();
      this.waitTime = 60;
      this.startWaitTimeInterval();
      this.service.createVerificationToken(this.target, this.password, ONE_TIME_PASSWORD_LOGIN_PURPOSE).subscribe({
        next: result => this.tokenId = result.tokenId,
        complete: () => this.service.displayMessage('verificationTokenForm.createVerificationToken', {
          target: this.target
        })
      });
    }
    startWaitTimeInterval() {
      const interval = setInterval(() => {
        this.waitTime--;
        this.cdr.detectChanges();
        if (this.waitTime <= 0) {
          clearInterval(interval);
          this.isResendDisabled = false;
          this.resendLink.nativeElement.tabIndex = 0;
          this.cdr.detectChanges();
        }
      }, 1000);
    }
    openInfoDailog() {
      this.launchDialogService.openDialogAndSubscribe("ACCOUNT_VERIFICATION_TOKEN" /* LAUNCH_CALLER.ACCOUNT_VERIFICATION_TOKEN */, this.element);
    }
    onOpenInfoDailogKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.openInfoDailog();
      }
    }
    startRateLimitWaitTimeInterval() {
      const interval = setInterval(() => {
        this.waitTimeForRateLimit--;
        this.cdr.detectChanges();
        if (this.waitTimeForRateLimit <= 0) {
          clearInterval(interval);
          this.upToRateLimit = false;
          this.isResendDisabled = false;
          this.cdr.detectChanges();
        }
      }, 1000);
    }
    static {
      this.ɵfac = function VerificationTokenFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VerificationTokenFormComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VerificationTokenFormComponent,
        selectors: [["cx-verification-token-form"]],
        viewQuery: function VerificationTokenFormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 5);
            i0.ɵɵviewQuery(_c7, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resendLink = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function VerificationTokenFormComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("user-form", ctx.style);
          }
        },
        standalone: false,
        decls: 28,
        vars: 30,
        consts: [["requiredAsterisk", ""], ["resendLink", ""], ["noReceiveCodeLink", ""], ["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], ["class", "form-legend", 4, "cxFeature"], [1, "label-content"], [3, "ngTemplateOutlet"], ["required", "true", "formControlName", "tokenCode", "aria-describedby", "tokenInputHint", 1, "form-control", 3, "placeholder"], [3, "control"], ["class", "rate-limit-error-display", 4, "ngIf"], ["id", "tokenInputHint", 1, "cx-visually-hidden"], ["type", "hidden", "formControlName", "tokenId", 3, "ngModelChange", "ngModel"], ["class", "resend-link-text", 4, "ngIf"], [1, "verify-container"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "btn", "btn-block", "btn-secondary", "btn-register", 3, "routerLink"], [1, "overlay"], [1, "form-legend"], [1, "rate-limit-error-display"], [1, "resend-link-text"], [1, "left-text"], ["role", "timer", "aria-live", "polite", "aria-atomic", "true"], ["role", "button", "tabindex", "-1", 1, "btn-link", 3, "keydown.enter", "keydown.space", "click", "ngClass"], [4, "ngIf"], [1, "right-text"], ["role", "button", "tabindex", "0", 1, "btn-link", 3, "keydown", "click"], ["class", "text-decoration-none required-asterisk", "aria-hidden", "true", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
        template: function VerificationTokenFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, VerificationTokenFormComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 3);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelementStart(2, "form", 4);
            i0.ɵɵlistener("ngSubmit", function VerificationTokenFormComponent_Template_form_ngSubmit_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSubmit());
            });
            i0.ɵɵtemplate(3, VerificationTokenFormComponent_p_3_Template, 3, 3, "p", 5);
            i0.ɵɵelementStart(4, "label")(5, "span", 6);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵtemplate(8, VerificationTokenFormComponent_ng_template_8_Template, 0, 0, "ng-template", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input", 8);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵelement(11, "cx-form-errors", 9);
            i0.ɵɵtemplate(12, VerificationTokenFormComponent_div_12_Template, 3, 6, "div", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "span", 11);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "input", 12);
            i0.ɵɵtwoWayListener("ngModelChange", function VerificationTokenFormComponent_Template_input_ngModelChange_16_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.tokenId, $event) || (ctx.tokenId = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(17, VerificationTokenFormComponent_div_17_Template, 13, 10, "div", 13);
            i0.ɵɵelementStart(18, "div", 14)(19, "button", 15);
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "button", 16);
            i0.ɵɵpipe(23, "cxUrl");
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "cxTranslate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(26, VerificationTokenFormComponent_ng_template_26_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const requiredAsterisk_r4 = i0.ɵɵreference(27);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 15, ctx.isUpdating$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 17, "verificationTokenForm.verificationCode.label"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r4);
            i0.ɵɵadvance();
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(10, 19, "verificationTokenForm.verificationCode.placeholder"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("control", ctx.form.get("tokenCode"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.upToRateLimit);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 21, "verificationTokenForm.tokenInputHint"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.tokenId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.upToRateLimit);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.form.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 23, "verificationTokenForm.verify"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(23, 25, i0.ɵɵpureFunction0(29, _c4)));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 27, "verificationTokenForm.back"), " ");
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf, i1$1.NgTemplateOutlet, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.FormGroupDirective, i2.FormControlName, i1$2.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i1.FeatureDirective, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return VerificationTokenFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let VerificationTokenFormModule = /*#__PURE__*/(() => {
  class VerificationTokenFormModule {
    static {
      this.ɵfac = function VerificationTokenFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VerificationTokenFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: VerificationTokenFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            VerifyOTPTokenComponent: {
              component: VerificationTokenFormComponent,
              guards: [NotAuthGuard],
              providers: [{
                provide: VerificationTokenFormComponentService,
                useClass: VerificationTokenFormComponentService,
                deps: [AuthService, GlobalMessageService, VerificationTokenFacade, WindowRef]
              }]
            }
          }
        }), provideDefaultConfig(defaultVerificationTokenLayoutConfig)],
        imports: [CommonModule, FormsModule, KeyboardFocusModule, ReactiveFormsModule, RouterModule, UrlModule, IconModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule]
      });
    }
  }
  return VerificationTokenFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UserAccountComponentsModule = /*#__PURE__*/(() => {
  class UserAccountComponentsModule {
    static {
      this.ɵfac = function UserAccountComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserAccountComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UserAccountComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [LoginModule, LoginFormModule, VerificationTokenFormModule, LoginRegisterModule, MyAccountV2UserModule, OneTimePasswordLoginFormModeule]
      });
    }
  }
  return UserAccountComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LoginComponent, LoginFormComponent, LoginFormComponentService, LoginFormModule, LoginModule, LoginRegisterComponent, LoginRegisterModule, MyAccountV2UserComponent, MyAccountV2UserModule, OneTimePasswordLoginFormComponent, OneTimePasswordLoginFormModeule, UserAccountComponentsModule, VerificationTokenFormComponent, VerificationTokenFormComponentService, VerificationTokenFormModule };
